__turbopack_context__.v({
  "custom_arrow": "CountrySelector-module-scss-module__bljglq__custom_arrow",
  "selector_button": "CountrySelector-module-scss-module__bljglq__selector_button",
  "selector_container": "CountrySelector-module-scss-module__bljglq__selector_container",
});
